import * as React from "react";

export const CrosswalkEditIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="800" height="800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" fill="#ffffff" {...props}>
    <g>
      <title>Layer 1</title>
      <g stroke="null" id="svg_1">
        <g stroke="null" id="svg_2">
          <path
            stroke="null"
            id="svg_3"
            className="st0"
            d="m390.1995,127.48947c35.1454,0 63.63858,-28.31686 63.63858,-63.25876c0,-34.91389 -28.49318,-63.23074 -63.63858,-63.23074c-35.1454,0 -63.637,28.31686 -63.637,63.23074c0,34.94191 28.49162,63.25876 63.637,63.25876z"
            fill="#ffffff"
          />
          <path
            stroke="null"
            id="svg_4"
            className="st0"
            d="m519.75254,667.16123c3.95655,-7.338 4.65984,-15.98359 1.93755,-23.86018l-40.21249,-115.7985c-5.64977,-16.2918 -14.0093,-31.49395 -24.74024,-45.01183l-65.27852,-85.7849l23.93984,-123.78407l30.91787,39.02188c3.80932,4.83338 8.75268,8.6845 14.38834,11.22961l81.29271,36.47676c5.88002,2.63851 12.58706,2.80039 18.57516,0.44364c6.01629,-2.35675 10.79831,-7.02979 13.29191,-12.94036l0.24435,-0.61955c4.75383,-11.33701 0.0141,-24.39723 -10.93458,-30.121l-72.86584,-38.09256l-30.71423,-62.71862c-15.50044,-31.64184 -45.1715,-54.10261 -79.99266,-60.53775l-31.60861,-5.84362c-15.90611,-2.92338 -32.32756,-0.80789 -46.95869,6.05844l-92.05031,43.19522c-10.21563,4.79445 -18.29165,13.14115 -22.73533,23.44301l-40.94397,94.99555c-2.60168,6.03198 -2.64084,12.85786 -0.1488,18.9163c2.5077,6.07401 7.37116,10.90583 13.46734,13.39801l0.92101,0.36425c12.208,4.96724 26.18911,-0.51213 31.70417,-12.4002l37.58418,-80.8706l59.46429,-19.1062l-58.93801,260.28899l-57.39203,142.22869c-3.18436,7.87661 -2.81784,16.72299 0.96172,24.31785c3.77956,7.62132 10.63541,13.26258 18.85867,15.55239l2.47951,0.67247c13.19635,3.66122 27.20721,-2.00651 34.0756,-13.78872l68.02901,-116.78074l40.53828,-79.92727l73.96227,81.12589l54.62902,115.02952c6.16508,12.96838 20.74452,19.75377 34.71308,16.15793l0.60931,-0.16188c8.10421,-2.08435 14.94595,-7.4423 18.92915,-14.76786l-0.00003,0z"
            fill="#ffffff"
          />
          <polygon
            stroke="null"
            id="svg_5"
            className="st0"
            points="23.408022231917585,798 105.88015162431657,798 191.07459620164082,703.2876420155008 123.3025331703393,703.2876420155008 "
            fill="#ffffff"
          />
          <polygon
            stroke="null"
            id="svg_6"
            className="st0"
            points="214.97376341697964,798 297.44595940863655,798 321.9558966656805,703.2876420155008 254.19787432499288,703.2876420155008 "
            fill="#ffffff"
          />
          <polygon
            stroke="null"
            id="svg_7"
            className="st0"
            points="372.04421132199786,703.2876420155008 396.55408589738727,798 479.02631322987145,798 439.7880676087625,703.2876420155008 "
            fill="#ffffff"
          />
          <polygon
            stroke="null"
            id="svg_8"
            className="st0"
            points="570.6693367319749,703.2876420155008 502.91134573211457,703.2876420155008 588.0932696489472,798 670.5919799804688,798 "
            fill="#ffffff"
          />
        </g>
      </g>
      <g stroke="null" id="svg_9" />
      <g stroke="null" id="svg_10">
        <path
          stroke="null"
          d="m746.10786,18.38516a19.8002,18.08864 0 1 1 28.00593,25.58506l-94.52003,86.34959l-38.50816,9.5944l10.50223,-35.17946l94.52003,-86.34959z"
          id="svg_11"
        />
      </g>
    </g>
  </svg>
);
